/* doing this so we're not dynamically importing images with 'require' */
import DGI from "images/partners/DGI.png";
import TGR from "images/partners/TGR.png";
import amendis from "images/partners/amendis.png";
import cnss from "images/partners/cnss.png";
import ctm from "images/partners/ctm.png";
import iam from "images/partners/iam.png";
import inwi from "images/partners/inwi.png";
import jawaz from "images/partners/jawaz.png";
import lydec from "images/partners/lydec.png";
import mamdaMcma from "images/partners/mamda-mcma.png";
import moneygram from "images/partners/moneygram.png";
import oncf from "images/partners/oncf.png";
import oneep from "images/partners/oneep.png";
import orange from "images/partners/orange.png";
import radeec from "images/partners/radeec.png";
import radeef from "images/partners/radeef.png";
import radeej from "images/partners/radeej.png";
import radeel from "images/partners/radeel.png";
import radeema from "images/partners/radeema.png";
import radeeo from "images/partners/radeeo.png";
import radees from "images/partners/radees.png";
import radeet from "images/partners/radeet.png";
import radem from "images/partners/radem.png";
import rak from "images/partners/rak.png";
import ramsa from "images/partners/ramsa.png";
import redal from "images/partners/redal.png";
import remitly from "images/partners/remitly.png";
import ria from "images/partners/ria.png";
import wu from "images/partners/wu.png";
import proxicash from "images/partners/proxicash.png";
// import moneytrans from "images/partners/moneytrans.png";
import juba from "images/partners/juba.png";
// eslint-disable-next-line import/prefer-default-export
export const CAROUSEL_IMAGES = [
  DGI,
  TGR,
  amendis,
  cnss,
  ctm,
  iam,
  inwi,
  jawaz,
  lydec,
  mamdaMcma,
  oncf,
  oneep,
  orange,
  radeec,
  radeef,
  radeej,
  radeel,
  radeema,
  radeeo,
  radees,
  radeet,
  radem,
  rak,
  ramsa,
  redal,
  remitly,
  ria,
  moneygram,
  wu,
  proxicash,
  // moneytrans,
  juba,
];
